import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11fc6e86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "containers" }
const _hoisted_2 = { class: "bg-white rounded mt-3" }
const _hoisted_3 = { class: "py-3 px-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-filter mr-2" }, null, -1))
const _hoisted_5 = { class: "grid grid-cols-4 gap-4 mb-2" }
const _hoisted_6 = { class: "mt-1 flex items-center justify-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_9 = { class: "flex items-center justify-end mt-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "pb-4 flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Загрузка данных...", -1))
const _hoisted_13 = { class: "flex items-center justify-end py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_containers_page_invoice_panel = _resolveComponent("containers-page-invoice-panel")!
  const _component_modal_panel = _resolveComponent("modal-panel")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_record_container_row = _resolveComponent("record-container-row")!
  const _component_record_container_invoice_row = _resolveComponent("record-container-invoice-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.invoice_state.is_opened && _ctx.invoice_state.invoice)
      ? (_openBlock(), _createBlock(_component_modal_panel, {
          key: 0,
          title: "Информация",
          "without-footer": "",
          onCancel: _ctx.closeInvoicePanel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_containers_page_invoice_panel, {
              "invoice-id": _ctx.invoice_state.invoice.id,
              onCancel: _ctx.closeInvoicePanel
            }, null, 8, ["invoice-id", "onCancel"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Контейнеры" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_new_button, {
          disabled: _ctx.state.is_loading,
          class: "NewButton--outline",
          onClick: _ctx.toggleFilters
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Фильтр ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _withDirectives(_createElementVNode("form", {
          class: "mt-6",
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFilters && _ctx.submitFilters(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              placeholder: "Номер накладной",
              value: _ctx.filters_state.invoiceNumber,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.invoiceNumber) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              type: "date",
              placeholder: "Дата с",
              value: _ctx.filters_state.dateFrom,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.dateFrom) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              type: "date",
              placeholder: "Дата по",
              value: _ctx.filters_state.dateTo,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.dateTo) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_select, {
              "can-deselect": "",
              disabled: _ctx.state.is_loading,
              placeholder: "Диспетчер",
              loading: _ctx.dispatchers_state.is_loading,
              failed: _ctx.dispatchers_state.is_failed,
              "error-text": "При получении диспетчеров произошла ошибка",
              options: _ctx.dispatchers_state.list,
              "search-without-refresh": "",
              value: _ctx.filters_state.userId,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.userId) = $event)),
              onRefresh: _ctx.loadDispatchers
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
            _createVNode(_component_new_select, {
              "can-deselect": "",
              disabled: _ctx.state.is_loading,
              placeholder: "Курьер",
              loading: _ctx.couriers_state.is_loading,
              failed: _ctx.couriers_state.is_failed,
              "error-text": "При получении курьеров произошла ошибка",
              options: _ctx.couriers_state.list,
              "search-without-refresh": "",
              value: _ctx.filters_state.courierId,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.courierId) = $event)),
              label: "fullName",
              onRefresh: _ctx.loadCouriers
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
            _createVNode(_component_new_input, {
              disabled: _ctx.state.is_loading,
              placeholder: "Название контейнера",
              value: _ctx.filters_state.title,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.title) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_select, {
              "can-deselect": "",
              disabled: _ctx.state.is_loading,
              placeholder: "Сектор",
              loading: _ctx.sectors_state.is_loading,
              failed: _ctx.sectors_state.is_failed,
              "error-text": "При получении секторов произошла ошибка",
              options: _ctx.sectors_state.list,
              "search-without-refresh": "",
              value: _ctx.filters_state.sectorId,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters_state.sectorId) = $event)),
              onRefresh: _ctx.loadSectors
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
            _createVNode(_component_new_select, {
              "can-deselect": "",
              placeholder: "Статус",
              disabled: _ctx.state.is_loading,
              options: _ctx.STATUSES,
              value: _ctx.filters_state.statusIds,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.statusIds) = $event)),
              multiselect: "",
              "search-without-refresh": ""
            }, null, 8, ["disabled", "options", "value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_new_button, {
              disabled: _ctx.state.is_loading,
              class: "NewButton--reset mr-2",
              onClick: _ctx.resetFilters
            }, {
              "icon-left": _withCtx(() => [
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_new_button, {
              disabled: _ctx.state.is_loading,
              loading: _ctx.state.is_loading,
              class: "NewButton--search",
              type: "submit"
            }, {
              "icon-left": _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Поиск ")
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ], 544), [
          [_vShow, _ctx.state.is_filters_opened]
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_new_button, {
            disabled: _ctx.state.is_loading || _ctx.excel_state.is_loading,
            loading: _ctx.excel_state.is_loading,
            hint: "Скачать Excel",
            class: "mr-3",
            onClick: _ctx.exportExcel
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"]),
          _createVNode(_component_new_limit, {
            disabled: _ctx.state.is_loading,
            value: _ctx.filters_state.limit,
            "total-items": _ctx.state.total_items,
            onChange: _ctx.onLimitChange
          }, null, 8, ["disabled", "value", "total-items", "onChange"]),
          _createVNode(_component_new_pagination, {
            class: "ml-6",
            disabled: _ctx.state.is_loading,
            "current-page": _ctx.filters_state.page,
            "total-pages": _ctx.state.total_pages,
            onChangePage: _ctx.onChangePage
          }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.state.is_failed)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.is_loading,
              text: "При получении списка контейнеров произошла ошибка",
              onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadContainers(_ctx.filters_state.page)))
            }, null, 8, ["loading"]))
          : (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_12
              ]))
            : (_openBlock(), _createBlock(_component_new_table, {
                key: 2,
                class: "NewTable--small grid grid-cols-1 gap-4 mt-3",
                "has-index-column": "",
                columns: _ctx.COLUMNS,
                "nested-rows-expand-key": "invoices",
                "nested-rows": _ctx.state.list,
                "expanded-rows": _ctx.state.expanded_containers,
                "clickable-nested": "",
                "regular-table": "",
                onClickNested: _ctx.openInvoicePanel,
                onClickRow: _ctx.toggleContainer
              }, {
                "nested-td": _withCtx(({ column, row, rowindex }) => [
                  _createVNode(_component_record_container_row, {
                    index: rowindex,
                    column: column,
                    row: row,
                    expanded: _ctx.isContainerExpanded(row.id),
                    "regular-table": "",
                    onToggle: _ctx.toggleContainer
                  }, null, 8, ["index", "column", "row", "expanded", "onToggle"])
                ]),
                "nested-row-td": _withCtx(({ column, row }) => [
                  _createVNode(_component_record_container_invoice_row, {
                    column: column,
                    row: row
                  }, null, 8, ["column", "row"])
                ]),
                "nested-row-table-index": _withCtx(() => []),
                _: 1
              }, 8, ["columns", "nested-rows", "expanded-rows", "onClickNested", "onClickRow"]))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.filters_state.limit,
          "total-items": _ctx.state.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.filters_state.page,
          "total-pages": _ctx.state.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ])
    ])
  ]))
}